import CheckIconAlt from '@src/svgs/CheckIconAlt';
import React from 'react';
import styled from 'styled-components';

/**
 * The tick box the Reel Editor's clip filters share — the speaker dropdown's
 * rows and the picker's two "hide these" checkboxes. One definition, so the
 * controls in and around the picker read as one set rather than as three
 * near-identical boxes.
 *
 * Gold when ticked (`--accent`, the design system's visual-indication colour:
 * these mark state, they are not the thing being confirmed), 14px so it sits on
 * a text line without setting the row's height.
 */
export const ClipFilterCheckbox: React.FC<{ checked: boolean }> = ({
  checked,
}) => <Box $checked={checked}>{checked && <CheckIconAlt />}</Box>;

const Box = styled.span<{ $checked: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid
    ${props => (props.$checked ? 'var(--accent)' : 'var(--border)')};
  background-color: ${props =>
    props.$checked ? 'var(--accent)' : 'transparent'};
  color: var(--background);
`;
